import { gql } from 'apollo-boost';

export const SEARCH_PEOPLE = gql`
  query($search: String, $page: Int = 1) {
    people(limit: 30, search: $search, page: $page) {
      total
      page
      pages
      docs {
        id
        firstName
        lastName
        avatar
        relationship
        household {
          id
          primary {
            person {
              id
              lastName
            }
          }
        }
      }
    }
  }
`;

export const PERSON = gql`
  query PERSON($id: ID) {
    getPerson(id: $id) {
      id
      firstName
      lastName
      relationship
      gender
      birthMonth
      birthYear
      allergies
      ethnicity
      addressIsShared
      addressLineOne
      addressLineTwo
      city
      state
      postal
      notes
      primary
      activity {
        date
        type
        event {
          id
          date
          name
        }
      }
      household {
        id
        people {
          id
          firstName
          lastName
          avatar
          relationship
          household {
            id
            primary {
              person {
                id
                lastName
              }
            }
          }
        }
        primary {
          user {
            id
            email
            phone
            notificationPreference
          }
          person {
            id
            firstName
            lastName
            addressLineOne
            addressLineTwo
            city
            state
            postal
          }
        }
      }
    }
  }
`;
